import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue";
const _hoisted_1 = ["aria-label"];
const _hoisted_2 = {
  class: "app-nav-menu__profile-avatar",
  "aria-hidden": "true"
};
const _hoisted_3 = {
  key: 1,
  class: "app-nav-menu__profile-avatar-fallback"
};
const _hoisted_4 = {
  class: "app-nav-menu__profile-text"
};
const _hoisted_5 = {
  class: "app-nav-menu__profile-name"
};
const _hoisted_6 = {
  key: 0,
  class: "app-nav-menu__profile-balance"
};
const _hoisted_7 = {
  class: "app-nav-menu__profile-balance-label"
};
const _hoisted_8 = {
  class: "app-nav-menu__profile-balance-value"
};
const _hoisted_9 = ["aria-disabled", "aria-busy", "aria-label", "onKeydown"];
const _hoisted_10 = ["aria-label", "onKeydown"];
const _hoisted_11 = ["aria-label", "onKeydown"];
const _hoisted_12 = {
  class: "app-nav-menu__icon app-nav-menu__icon--yellow",
  "aria-hidden": "true"
};
const _hoisted_13 = {
  class: "app-nav-menu__label u-ltr-isolate",
  dir: "ltr"
};
const _hoisted_14 = {
  class: "app-nav-menu__icon app-nav-menu__icon--violet",
  "aria-hidden": "true"
};
const _hoisted_15 = {
  class: "app-nav-menu__label"
};
const _hoisted_16 = {
  class: "app-nav-menu__icon app-nav-menu__icon--cyan",
  "aria-hidden": "true"
};
const _hoisted_17 = {
  class: "app-nav-menu__label"
};
const _hoisted_18 = {
  class: "app-nav-menu__icon app-nav-menu__icon--orange",
  "aria-hidden": "true"
};
const _hoisted_19 = {
  class: "app-nav-menu__label"
};
const _hoisted_20 = {
  class: "app-nav-menu__icon app-nav-menu__icon--gold",
  "aria-hidden": "true"
};
const _hoisted_21 = {
  class: "app-nav-menu__label"
};
const _hoisted_22 = {
  class: "app-nav-menu__icon app-nav-menu__icon--green",
  "aria-hidden": "true"
};
const _hoisted_23 = {
  class: "app-nav-menu__label"
};
const _hoisted_24 = {
  class: "app-nav-menu__icon app-nav-menu__icon--blue",
  "aria-hidden": "true"
};
const _hoisted_25 = {
  class: "app-nav-menu__label"
};
const _hoisted_26 = ["disabled", "aria-busy"];
const _hoisted_27 = {
  class: "app-nav-menu__label"
};
import { ref, computed, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { useI18n } from 'vue-i18n';
import { Trophy, Present, QuestionFilled, Edit, CopyDocument, List, Grid, Lightning, Loading, Share } from '@element-plus/icons-vue';
import NavLogoutIcon from '@/components/icons/NavLogoutIcon.vue';
import AppImage from '@/components/common/AppImage.vue';
import AppNavLocalePicker from '@/components/nav/AppNavLocalePicker.vue';
import { usePortfolioBalanceStore } from '@/stores/portfolioBalance';
import { readPositionTotalField } from '@/domain/user/portfolio-totals';
import { formatUsdcApproxTruncated } from '@/utils/points-usdc-rate';
import { resolveMediaUrl } from '@/utils/resolve-media-url';
import { getUserId } from '@/utils/auth-token';
import { copyTextWithHint, hintAnchorFromEvent } from '@/utils/copy-with-hint';
export default {
  __name: 'AppNavUserMenuPanel',
  props: {
    profile: {
      type: Object,
      default: null
    },
    profileLoading: {
      type: Boolean,
      default: false
    },
    balanceLabel: {
      type: String,
      default: ''
    },
    /** H5 Drawer：隐藏语言切换（改在「更多」弹窗） */
    hideLocalePicker: {
      type: Boolean,
      default: false
    },
    /** H5 Drawer：与「更多」弹窗对齐的内边距与菜单样式 */
    h5Layout: {
      type: Boolean,
      default: false
    },
    loggingOut: {
      type: Boolean,
      default: false
    }
  },
  emits: ['close', 'logout', 'switch-locale', 'open-settings', 'open-my-copy', 'navigate', 'account-tab'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const {
      t
    } = useI18n();
    const portfolioStore = usePortfolioBalanceStore();
    const {
      positionTotal
    } = storeToRefs(portfolioStore);
    const avatarFailed = ref(false);
    const displayName = computed(() => {
      const api = props.profile;
      return api?.nickName || api?.username || api?.email || 'User';
    });
    const profileUserId = computed(() => {
      const api = props.profile;
      return String(api?.userId ?? api?.id ?? getUserId() ?? '').trim();
    });
    async function copyUserIdentity(event) {
      const name = String(displayName.value || '').trim();
      const safeName = name && name !== '…' ? name : '';
      const id = profileUserId.value;
      const text = safeName && id ? `${safeName}\n${id}` : safeName || id;
      if (!text) return;
      await copyTextWithHint({
        text,
        anchor: hintAnchorFromEvent(event),
        successText: t('account.copyUserIdentitySuccess'),
        failText: t('account.copyUserIdentityFailed')
      });
    }
    const avatarUrl = computed(() => resolveMediaUrl(String(props.profile?.avatar ?? '').trim()));
    watch(avatarUrl, () => {
      avatarFailed.value = false;
    });
    const avatarInitial = computed(() => {
      if (props.profileLoading) return '…';
      const name = String(displayName.value || '').trim();
      if (!name || name === 'User') return '?';
      const parts = name.split(/\s+/).filter(Boolean);
      if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
      return name.slice(0, 2).toUpperCase();
    });

    /** 菜单首项：我的 DScoin（约合 USD） */
    const myDscoinLabel = computed(() => {
      if (positionTotal.value == null) {
        return t('nav.myDscoin', {
          amount: '…'
        });
      }
      const points = readPositionTotalField(positionTotal.value, 'pointsBalance');
      const usd = formatUsdcApproxTruncated(points);
      return t('nav.myDscoin', {
        amount: `$${usd}`
      });
    });
    function emitNavigate(path) {
      emit('close');
      emit('navigate', path);
    }
    function emitAccountTab(tab) {
      emit('close');
      emit('account-tab', tab);
    }
    function emitSettings() {
      emit('close');
      emit('open-settings');
    }
    function emitLogout() {
      if (props.loggingOut) return;
      emit('logout');
    }
    function emitSwitchLocale(code) {
      emit('switch-locale', code);
    }
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["app-nav-menu app-nav-menu--user", {
          'app-nav-menu--h5': __props.h5Layout
        }])
      }, [_createElementVNode("button", {
        type: "button",
        class: "app-nav-menu__profile app-nav-menu__profile-link",
        "aria-label": _ctx.$t('nav.account'),
        onClick: _cache[2] || (_cache[2] = $event => emitNavigate('/account'))
      }, [_createElementVNode("span", _hoisted_2, [avatarUrl.value && !avatarFailed.value ? (_openBlock(), _createBlock(AppImage, {
        key: 0,
        src: avatarUrl.value,
        alt: "",
        class: "app-nav-menu__profile-avatar-img",
        eager: "",
        onError: _cache[0] || (_cache[0] = $event => avatarFailed.value = true)
      }, null, 8, ["src"])) : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(avatarInitial.value), 1))]), _createElementVNode("div", _hoisted_4, [_createElementVNode("p", _hoisted_5, _toDisplayString(displayName.value), 1), __props.balanceLabel ? (_openBlock(), _createElementBlock("p", _hoisted_6, [_createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('nav.availableBalance')), 1), _createElementVNode("span", _hoisted_8, _toDisplayString(__props.balanceLabel), 1)])) : _createCommentVNode("", true)]), __props.h5Layout ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        role: "button",
        tabindex: "0",
        class: _normalizeClass(["app-nav-menu__settings-btn app-nav-menu__settings-btn--logout", {
          'is-disabled': __props.loggingOut
        }]),
        "aria-disabled": __props.loggingOut ? 'true' : undefined,
        "aria-busy": __props.loggingOut ? 'true' : undefined,
        "aria-label": __props.loggingOut ? _ctx.$t('nav.loggingOut') : _ctx.$t('nav.logout'),
        onClick: _withModifiers(emitLogout, ["stop"]),
        onKeydown: [_withKeys(_withModifiers(emitLogout, ["stop", "prevent"]), ["enter"]), _withKeys(_withModifiers(emitLogout, ["stop", "prevent"]), ["space"])]
      }, [__props.loggingOut ? (_openBlock(), _createBlock(_component_el_icon, {
        key: 0,
        class: "is-loading"
      }, {
        default: _withCtx(() => [_createVNode(_unref(Loading))]),
        _: 1
      })) : (_openBlock(), _createBlock(NavLogoutIcon, {
        key: 1
      }))], 42, _hoisted_9)) : (_openBlock(), _createElementBlock("span", {
        key: 1,
        class: "app-nav-menu__profile-actions",
        onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
      }, [_createElementVNode("span", {
        role: "button",
        tabindex: "0",
        class: "app-nav-menu__settings-btn",
        "aria-label": _ctx.$t('account.copyUserIdentity'),
        onClick: copyUserIdentity,
        onKeydown: [_withKeys(_withModifiers(copyUserIdentity, ["stop", "prevent"]), ["enter"]), _withKeys(_withModifiers(copyUserIdentity, ["stop", "prevent"]), ["space"])]
      }, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_unref(CopyDocument))]),
        _: 1
      })], 40, _hoisted_10), _createElementVNode("span", {
        role: "button",
        tabindex: "0",
        class: "app-nav-menu__settings-btn",
        "aria-label": _ctx.$t('nav.settings'),
        onClick: emitSettings,
        onKeydown: [_withKeys(_withModifiers(emitSettings, ["stop", "prevent"]), ["enter"]), _withKeys(_withModifiers(emitSettings, ["stop", "prevent"]), ["space"])]
      }, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_unref(Edit))]),
        _: 1
      })], 40, _hoisted_11)]))], 8, _hoisted_1), _cache[11] || (_cache[11] = _createElementVNode("div", {
        class: "app-nav-menu__divider"
      }, null, -1)), _createElementVNode("button", {
        type: "button",
        class: "app-nav-menu__row",
        onClick: _cache[3] || (_cache[3] = $event => emitNavigate('/account/points'))
      }, [_createElementVNode("span", _hoisted_12, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_unref(Lightning))]),
        _: 1
      })]), _createElementVNode("span", _hoisted_13, _toDisplayString(myDscoinLabel.value), 1)]), _createElementVNode("button", {
        type: "button",
        class: "app-nav-menu__row",
        onClick: _cache[4] || (_cache[4] = $event => emitAccountTab('positions'))
      }, [_createElementVNode("span", _hoisted_14, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_unref(List))]),
        _: 1
      })]), _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('nav.myPositions')), 1)]), _createElementVNode("button", {
        type: "button",
        class: "app-nav-menu__row",
        onClick: _cache[5] || (_cache[5] = $event => emit('open-my-copy'))
      }, [_createElementVNode("span", _hoisted_16, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_unref(Share))]),
        _: 1
      })]), _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('nav.myCopyTrades')), 1)]), _createElementVNode("button", {
        type: "button",
        class: "app-nav-menu__row",
        onClick: _cache[6] || (_cache[6] = $event => emitAccountTab('createMarkets'))
      }, [_createElementVNode("span", _hoisted_18, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_unref(Grid))]),
        _: 1
      })]), _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t('nav.myCreatedMarkets')), 1)]), _createElementVNode("button", {
        type: "button",
        class: "app-nav-menu__row",
        onClick: _cache[7] || (_cache[7] = $event => emitNavigate('/leagues'))
      }, [_createElementVNode("span", _hoisted_20, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_unref(Trophy))]),
        _: 1
      })]), _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t('nav.leaderboard')), 1)]), _createElementVNode("button", {
        type: "button",
        class: "app-nav-menu__row",
        onClick: _cache[8] || (_cache[8] = $event => emitNavigate('/referrals'))
      }, [_createElementVNode("span", _hoisted_22, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_unref(Present))]),
        _: 1
      })]), _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t('nav.invite')), 1)]), _createElementVNode("button", {
        type: "button",
        class: "app-nav-menu__row",
        onClick: _cache[9] || (_cache[9] = $event => emitNavigate('/help'))
      }, [_createElementVNode("span", _hoisted_24, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_unref(QuestionFilled))]),
        _: 1
      })]), _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t('nav.help')), 1)]), !__props.hideLocalePicker ? (_openBlock(), _createBlock(AppNavLocalePicker, {
        key: 0,
        onSwitchLocale: emitSwitchLocale
      })) : _createCommentVNode("", true), !__props.h5Layout ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_cache[10] || (_cache[10] = _createElementVNode("div", {
        class: "app-nav-menu__divider"
      }, null, -1)), _createElementVNode("button", {
        type: "button",
        class: "app-nav-menu__row app-nav-menu__row--danger",
        disabled: __props.loggingOut,
        "aria-busy": __props.loggingOut ? 'true' : undefined,
        onClick: emitLogout
      }, [__props.loggingOut ? (_openBlock(), _createBlock(_component_el_icon, {
        key: 0,
        class: "is-loading",
        size: 14
      }, {
        default: _withCtx(() => [_createVNode(_unref(Loading))]),
        _: 1
      })) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_27, _toDisplayString(__props.loggingOut ? _ctx.$t('nav.loggingOut') : _ctx.$t('nav.logout')), 1)], 8, _hoisted_26)], 64)) : _createCommentVNode("", true)], 2);
    };
  }
};